import React from 'react';
import './cabinet/styles/cabinet.css'; // Global tokens and base styles

import { createRoot } from 'react-dom/client';
import { I18nProvider } from './cabinet/context/I18nContext';
import { AuthProvider } from './cabinet/context/AuthContext';
import { useAuth } from './cabinet/hooks/useAuth';
import { AuthShell } from './cabinet/components/auth/AuthShell';
import { FullscreenLoader } from './cabinet/components/ui/FullscreenLoader';

// A wrapper to handle redirection if user is already logged in
const AuthGuard: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="react-cabinet-isolated">
        <FullscreenLoader />
      </div>
    );
  }

  const isResetPassword = typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('action') === 'set_new_password';

  // If we are authenticated and in WP, and it's not a password reset, redirect to the cabinet
  if (isAuthenticated && !isResetPassword && typeof window !== 'undefined' && window.cabinetVars?.cabinetUrl) {
    // If the cabinet is already on this page (user added both shortcodes), don't redirect
    if (document.getElementById('react-cabinet') || document.getElementById('diet-panel-react')) {
      return null;
    }

    const currentUrl = window.location.href.split('?')[0].replace(/\/$/, '');
    const cabinetUrl = window.cabinetVars.cabinetUrl.split('?')[0].replace(/\/$/, '');
    
    // Normalize to prevent infinite redirect loops caused by trailing slashes
    if (currentUrl !== cabinetUrl && !currentUrl.includes('/moje-konto') && !currentUrl.includes('/my-account') && !currentUrl.includes('/panel-dietetyka')) {
      window.location.href = window.cabinetVars.cabinetUrl;
    } else {
      // If we are already on the cabinet page or panel, we need to reload to let PHP render the cabinet shortcode
      window.location.reload();
    }
    return null;
  }

  return (
    <div className="react-cabinet-isolated">
      <AuthShell />
    </div>
  );
};

const AuthApp: React.FC = () => {
  return (
    <I18nProvider>
      <AuthProvider>
        <AuthGuard />
      </AuthProvider>
    </I18nProvider>
  );
};

import { Sentry } from './sentry';

// Mount
const container = document.getElementById('react-auth');
if (container) {
  const root = createRoot(container);
  root.render(
    <Sentry.ErrorBoundary fallback={<p>Сталася помилка. Ми вже працюємо над цим.</p>}>
      <AuthApp />
    </Sentry.ErrorBoundary>
  );
}

export default AuthApp;
